import React from 'react'

const ArtistSelector = ({ artists, selectedArtist, onArtistSelect }) => {
  return (
    <div className="mb-6">
      <label htmlFor="artistSelect" className="block text-sm font-medium text-gray-200 mb-2">
        Select an artist to view details
      </label>
      <select
        id="artistSelect"
        value={selectedArtist}
        onChange={(e) => onArtistSelect(e.target.value)}
        className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 hover:bg-white/10"
      >
        <option value="" className="bg-gray-900">Select an artist...</option>
        {artists.map((artist, index) => (
          <option key={index} value={artist} className="bg-gray-900">{artist}</option>
        ))}
      </select>
    </div>
  )
}

export default ArtistSelector